import styled from 'styled-components';
import Pagination from '../../components/pagination/Pagination';
import { useEffect, useState } from 'react';
import GameService from '../../../service/game/GameService';

type MatchItem = {
  itemId: number;
  address: string;
  category: string;
  buildingName?: string;
};

type Match = {
  match_no: number;
  round_no: number;
  winner_item_id: number;
  left_item: MatchItem;
  right_item: MatchItem;
  left_item_id: number;
  right_item_id: number;
};

const Myhistory = ({
  gameId,
  playId,
  playerId,
}: {
  gameId: number;
  playId: number;
  playerId: string;
}) => {
  const [matchResults, setMatchResults] = useState<Match[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [active, setActive] = useState({
    start: false,
    lank: false,
    share: false,
  });

  useEffect(() => {
    const fetchMatchResults = async () => {
      try {
        const roundCount = 4; // 1~4 라운드 (8강 ~ 결승)
        const allRounds = await Promise.all(
          Array.from({ length: roundCount }, (_, i) =>
            GameService.getMatch(gameId, playId, i + 1, playerId),
          ),
        );
        const merged: Match[] = allRounds.flatMap((res) => res.data || []);
        const sortedData = merged.sort((a, b) => {
          if (a.round_no === b.round_no) {
            return a.match_no - b.match_no;
          }
          return b.round_no - a.round_no;
        });
        setMatchResults(sortedData);
      } catch (err) {
        console.error('[경기 기록 조회 실패]', err);
      }
    };

    fetchMatchResults();
  }, [gameId, playId, playerId]);

  const pageSize = 5;
  const totalPages = Math.ceil(matchResults.length / pageSize);
  const paginatedData = matchResults.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );
  const getRoundLabel = (roundNo: number) => {
    switch (roundNo) {
      case 1:
        return '8강';
      case 2:
        return '준결승';
      case 3:
        return '결승';
      case 4:
        return '우승';
      default:
        return `${roundNo}강`;
    }
  };
  return (
    <Container>
      <Inner>
        <Content id="list-top02">
          <Title>나의 선택 히스토리</Title>
          {paginatedData.map((match, index) => {
            const isLeftWinner = match.left_item_id === match.winner_item_id;

            return (
              <ListItem key={index}>
                <Geangy>
                  {getRoundLabel(match.round_no)}
                  <span>
                    {match.round_no === 4 ? '' : ` ${match.match_no}경기`}
                  </span>
                </Geangy>
                <WinLoos>
                  {isLeftWinner ? (
                    <>
                      <Winner>
                        <span>승</span>
                        {match.left_item.buildingName ||
                          match.left_item.address}
                      </Winner>
                      <Looser>
                        <span>패</span>
                        {match.right_item.buildingName ||
                          match.right_item.address}
                      </Looser>
                    </>
                  ) : (
                    <>
                      <Looser>
                        <span>패</span>
                        {match.left_item.buildingName ||
                          match.left_item.address}
                      </Looser>
                      <Winner>
                        <span>승</span>
                        {match.right_item.buildingName ||
                          match.right_item.address}
                      </Winner>
                    </>
                  )}
                </WinLoos>
              </ListItem>
            );
          })}
          <PageWrap>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              scrollTargetId="list-top02"
            />
          </PageWrap>
        </Content>
      </Inner>
    </Container>
  );
};

export default Myhistory;

const Container = styled.div`
  width: 100%;
  background: #f3f4f6;
  flex-direction: row;
  justify-content: center;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  width: 100%;
`;

const Title = styled.div`
  color: #000;

  /* Re_SPOQA/sub_h/bold_18 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const ListItem = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.08);
  background: #fff;
`;

const Geangy = styled.div`
  color: #333d4b;

  /* Re_SPOQA/body/b_13 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
  display: flex;
  gap: 6px;
  span {
    color: #4e5968;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 19.5px */
    letter-spacing: -0.26px;
  }
`;
const Winner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: #333d4b;
  gap: 4px;
  /* Re_SPOQA/body/med_16 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.28px;
  span {
    color: #008aff;
  }
`;
const Looser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  color: rgba(0, 25, 54, 0.31);

  /* Re_SPOQA/body/med_16 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.28px;
`;

const WinLoos = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 4px;
  flex: 1 0 0;
  flex-direction: column;
  width: 100%;
`;

const Info = styled.div`
  color: #008aff;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;
const PageWrap = styled.div`
  flex-direction: row;
  justify-content: center;
  width: 100%;
  > div {
    margin: 0;
  }
`;
